import React from "react";
import Hello from "components/comp/Hello";
import CompanyIntro from "components/comp/CompanyIntro";
import MajorBusiness from "components/comp/MajorBusiness";
import SubPicture from "components/comp/SubPicture";
import lapImg from "assets/images/lap.jpg"

// why: 회사소개 하위 메뉴 통합 페이지(소개 및 주요사업)

const AboutOverview = () => {
  return (
    <main className="page-sub">
      <SubPicture img={lapImg}/>
      <section className="company-main">
        <Hello/>
        <CompanyIntro/>
        <MajorBusiness/>
      </section>
    </main>
  );
};

export default AboutOverview;


